import { maybeReportAppInstall } from '../report-app-install';
import { useUserJourneyStore } from '~/stores/apostatudo/user-journey';
import type { AppsflyerConversionData } from '~/stores/apostatudo/user-journey';

export function handleAppsflyerConversionData(
  payload: AppsflyerConversionData,
): void {
  useUserJourneyStore().setAppsflyerConversionData(payload);

  // Nao dispara aqui: o UID pode ainda nao ter chegado. O coordenador
  // dispara o app_install quando conversion data + UID estiverem ambos
  // presentes — quem chegar por ultimo fecha a condicao.
  maybeReportAppInstall().catch(() => {
    // silencioso — nao bloqueia o fluxo de boot do app
  });
}
